/* Noémie theme — core interactivity (vanilla JS, no build step) */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------------------------------------------------
     Scroll reveal
     --------------------------------------------------------------------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------------------------------------------------------------------
     Mobile nav
     --------------------------------------------------------------------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () { mobileNav.classList.add('is-open'); });
  }
  if (menuClose && mobileNav) {
    menuClose.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
  }

  /* ---------------------------------------------------------------------
     Header search panel
     --------------------------------------------------------------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-header-search]');
  var searchClose = document.querySelector('[data-header-search-close]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      if (searchPanel.classList.contains('is-open')) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', function () { searchPanel.classList.remove('is-open'); });
  }

  /* ---------------------------------------------------------------------
     Cart drawer
     --------------------------------------------------------------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var cartIcon = document.querySelector('[data-cart-icon]');
  var cartCloseEls = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (cartIcon) cartIcon.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  if (overlay) overlay.addEventListener('click', closeCartDrawer);
  cartCloseEls.forEach(function (el) { el.addEventListener('click', closeCartDrawer); });

  function renderMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartDrawer(cart) {
    var itemsWrap = document.querySelector('[data-cart-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var emptyEl = document.querySelector('[data-cart-empty]');
    var footerEl = document.querySelector('[data-cart-footer]');

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (!itemsWrap) return;

    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';

    itemsWrap.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-item" data-line-key="' + item.key + '">' +
        '<div class="cart-item__media"><img src="' + (item.image || '') + '" alt="' + item.product_title + '" loading="lazy"></div>' +
        '<div>' +
          '<div class="cart-item__title">' + item.product_title + '</div>' +
          (item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '') +
          '<div class="qty-stepper" data-qty-stepper>' +
            '<button type="button" data-qty-decrease>&minus;</button>' +
            '<input type="text" value="' + item.quantity + '" data-qty-input readonly>' +
            '<button type="button" data-qty-increase>+</button>' +
          '</div>' +
          '<a href="#" class="cart-item__remove" data-cart-remove>Remove</a>' +
        '</div>' +
        '<div class="cart-item__line-price">' + renderMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');

    if (subtotalEl) subtotalEl.textContent = renderMoney(cart.total_price);
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var form = addBtn.closest('form');
      if (!form) return;
      var formData = new FormData(form);
      addBtn.setAttribute('disabled', 'true');
      var originalText = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = originalText;
          fetchCart();
          openCartDrawer();
        })
        .catch(function () {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = originalText;
        });
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      var line = removeBtn.closest('[data-line-key]');
      if (line) changeLine(line.getAttribute('data-line-key'), 0);
      return;
    }

    var qtyInc = e.target.closest('[data-qty-increase]');
    var qtyDec = e.target.closest('[data-qty-decrease]');
    if (qtyInc || qtyDec) {
      var lineEl = (qtyInc || qtyDec).closest('[data-line-key]');
      if (!lineEl) return;
      var input = lineEl.querySelector('[data-qty-input]');
      var val = parseInt(input.value, 10) || 1;
      val = qtyInc ? val + 1 : Math.max(0, val - 1);
      changeLine(lineEl.getAttribute('data-line-key'), val);
      return;
    }

    /* Accordion (product page) */
    var accTrigger = e.target.closest('[data-accordion-trigger]');
    if (accTrigger) {
      var item = accTrigger.closest('[data-accordion-item]');
      var content = item.querySelector('[data-accordion-content]');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      content.style.maxHeight = !isOpen ? content.scrollHeight + 'px' : '0px';
      return;
    }

    /* Gallery thumbnails */
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var mainImg = document.querySelector('[data-gallery-main-image]');
      var newSrc = thumb.getAttribute('data-full-src');
      if (mainImg && newSrc) mainImg.setAttribute('src', newSrc);
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    /* Variant swatches */
    var swatch = e.target.closest('[data-variant-option]');
    if (swatch && !swatch.classList.contains('is-disabled')) {
      var group = swatch.closest('[data-variant-group]');
      group.querySelectorAll('[data-variant-option]').forEach(function (s) { s.classList.remove('is-selected'); });
      swatch.classList.add('is-selected');
      updateSelectedVariant();
      return;
    }
  });

  /* ---------------------------------------------------------------------
     Variant selection -> price / availability / hidden input
     --------------------------------------------------------------------- */
  function updateSelectedVariant() {
    var productEl = document.querySelector('[data-product-json]');
    if (!productEl) return;
    var product = JSON.parse(productEl.textContent);
    var selected = [];
    document.querySelectorAll('[data-variant-group]').forEach(function (group) {
      var active = group.querySelector('.is-selected');
      selected.push(active ? active.getAttribute('data-variant-option') : null);
    });

    var match = product.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return val === null || opts[i] === val; });
    });

    var idInput = document.querySelector('[data-variant-id-input]');
    var priceEl = document.querySelector('[data-product-price]');
    var buyBtn = document.querySelector('[data-add-to-cart]');

    if (match) {
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = renderMoney(match.price);
      if (buyBtn) {
        buyBtn.removeAttribute('disabled');
        buyBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
        if (!match.available) buyBtn.setAttribute('disabled', 'true');
      }
    }
  }

  /* Init quantity steppers outside the cart (product page) */
  document.querySelectorAll('[data-product-qty]').forEach(function (stepper) {
    stepper.addEventListener('click', function (e) {
      var input = stepper.querySelector('input');
      if (e.target.matches('[data-qty-increase]')) input.value = (parseInt(input.value, 10) || 1) + 1;
      if (e.target.matches('[data-qty-decrease]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
  });

  /* Collection sort */
  var sortSelect = document.querySelector('[data-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
});
